import { render, staticRenderFns } from "./MDRReport.vue?vue&type=template&id=6ac46ea9"
import script from "./MDRReport.vue?vue&type=script&lang=js"
export * from "./MDRReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports